export enum InvoiceStepEnum {
  SETTINGS = "settings",
  SELECT_DRAW_AMOUNT = "selectDrawAmount",
  SELECT_COST_PLUS_ITEM = "selectCostPlusItems",
  SELECT_FIXED_ITEM = "selectFixedItems",
  REVIEW = "review",
}
